import { StyledOptions } from '@emotion/styled/base';

export const styledOptions: StyledOptions = {
  shouldForwardProp: propName => !propName.startsWith('$'),
};
